import { STORAGE_KEY, loadConsent, saveConsent } from "./storage";
import type { CategoryConfig, CookieConfig } from "./config";

export interface ConsentState {
  categories: Record<string, boolean>;
  cookies: Record<string, boolean>;
  optOut?: boolean;
}

function buildCookieConsent(cookies: CookieConfig[] | undefined, categoriesConsent: Record<string, boolean>): Record<string, boolean> {
  const cookieConsent: Record<string, boolean> = {};
  for (const cookie of cookies || []) {
    cookieConsent[cookie.key] = categoriesConsent[cookie.category] ?? false;
  }
  return cookieConsent;
}

export function buildDefaultConsent(categories: CategoryConfig[], cookies?: CookieConfig[]): ConsentState {
  const consent: Record<string, boolean> = {};
  for (const cat of categories) {
    consent[cat.key] = cat.required ? true : false;
  }
  return { categories: consent, cookies: buildCookieConsent(cookies, consent) };
}

export function buildAcceptAllConsent(categories: CategoryConfig[], cookies?: CookieConfig[]): ConsentState {
  const consent: Record<string, boolean> = {};
  for (const cat of categories) {
    consent[cat.key] = true;
  }
  return { categories: consent, cookies: buildCookieConsent(cookies, consent) };
}

export function buildRejectAllConsent(categories: CategoryConfig[], cookies?: CookieConfig[]): ConsentState {
  const consent: Record<string, boolean> = {};
  for (const cat of categories) {
    consent[cat.key] = cat.required ? true : false;
  }
  return { categories: consent, cookies: buildCookieConsent(cookies, consent) };
}

export function buildOptOutConsent(categories: CategoryConfig[], cookies?: CookieConfig[]): ConsentState {
  const consent: Record<string, boolean> = {};
  for (const cat of categories) {
    if (cat.key === "marketing" || cat.key === "analytics") {
      consent[cat.key] = false;
    } else {
      consent[cat.key] = cat.required ? true : false;
    }
  }
  return { categories: consent, cookies: buildCookieConsent(cookies, consent), optOut: true };
}

export function getConsent(): ConsentState | null {
  return loadConsent();
}

export function setConsent(consent: ConsentState): void {
  saveConsent(consent);
}

export function hasConsented(): boolean {
  return loadConsent() !== null;
}
